export const externalLinkMap: { [key: string]: string } = {
  twitter: 'https://twitter.com/talentbook_jp',
  youtube: 'https://www.youtube.com/@talentbook5091',
  instagram: 'https://www.instagram.com/talentbook_official/',
  facebook: 'https://www.facebook.com/talentbook.jp/',
  line: 'https://lin.ee/TQZJYTM',
  talentbook: 'http://talentbook.co.jp/',
  productTalentbook: 'https://product.talent-book.jp/',
  cmsLogin: 'https://dashboard.talent-book.jp/login',
  productTalentbookForm: 'https://product.talent-book.jp/interview-request',
  productTalentbookPrivacy: 'https://product.talent-book.jp/privacy-policy/',
  productTalentbookSecurity: 'https://product.talent-book.jp/security-policy',
  talentbookOfficial: '/talentbook_official',
}
